import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from "./components/Home";
import Persons from "./components/Persons";

import Person from "./components/Person";
import Annuals from "./components/Annuals";
import Annual from "./components/Annual";
import Accounts from "./components/Accounts";
import Account from "./components/Account";
import Tafsils from "./components/Tafsils";
import Tafsil from "./components/Tafsil";
import Documents from "./components/Documents";

import DragDropComponent from "./components/DragDrop";

import SampleComponent from './components/Sample';


import Document from "./components/Document";
import Stuffs from "./components/Stuffs";
import Stuff from "./components/Stuff";
import SaleInvoices from "./components/SaleInvoices";
import BuyInvoices from "./components/BuyInvoices";
import InvoiceSale from "./components/InvoiceSale";
import InvoiceBuy from "./components/InvoiceBuy";
import InvoiceView from "./components/InvoiceView";
import Upload from "./components/Upload";
import Login from "./components/Login";
import Register from "./components/Register";
import Remember from "./components/Remember";
import Profile from "./components/Profile";
import Company from "./components/Company";
import CompanySetting from "./components/CompanySetting";
import Companies from "./components/Companies";
import InquiryEconomicCode from "./components/InquiryEconomicCode";
import InquiryStuff from "./components/InquiryStuff";
import MyPlans from "./components/MyPlans";
import PaymentFailed from "./components/PaymentFailed";
import MyTransactions from "./components/MyTransactions";
import Warehouses from "./components/Warehouses";
import Warehouse from "./components/Warehouse";
import Remittances from "./components/Remittances";
import Remittance from "./components/Remittance";

import Units from "./components/Managments/Units";
import Unit from "./components/Managments/Unit";
import Plans from "./components/Managments/Plans";
import Plan from "./components/Managments/Plan";
import Users from "./components/Managments/Users";
import User from "./components/Managments/User";
import Transactions from "./components/Managments/Transactions";
import Setting from "./components/Managments/Setting";

import BaseStuffs from "./components/Managments/BaseStuffs";
import CSR from "./components/CSR";

import ExploreReport from "./components/ExploreReport";
import ExploreWarehouseReport from "./components/ExploreWarehouseReport";

import Archive from './components/Archive/Archive.jsx';
import ClosingDocument from './components/ClosingDocument';
import TaxConditions from './components/TaxConditions';
import TaxCondition from './components/TaxCondition';


import Operation from './components/PayReciv/Operation';
import Operations from './components/PayReciv/Operations';
import BankTransactions from './components/PayReciv/BankTransactions';
import BankTransaction from './components/PayReciv/BankTransaction';

import Banks from './components/PayReciv/Banks';
import Bank from './components/PayReciv/Bank';
import PricingRemittance from './components/PricingRemittance';

import  { ThemeProvider } from './components/ThemeContext';




export default class App extends Component {
    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
    render() {
        return (
            <ThemeProvider>
            <Layout>
                <Routes>
                    <Route exact path='/' element={<Home />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/register' element={<Register />} />
                    <Route path='/remember' element={<Remember />} />
                    <Route path='/profile' element={<Profile />} />

                    <Route path='/myplans' element={<MyPlans />} />

                    <Route path='/csr' element={<CSR />} />

                    <Route path='/Sample' element={<SampleComponent />} />
                    <Route path='/drag' element={<DragDropComponent />} />

                    <Route path='/report/explore/warehouse' element={<ExploreWarehouseReport />} />
                    <Route path='/report/explore' element={<ExploreReport />} />

                    <Route path='/remittance/new1' element={<Remittance IO={1} Id={this.getDefaultGuid()} />} />
                    <Route path='/remittance/new2' element={<Remittance IO={2} Id={this.getDefaultGuid()} />} />
                    <Route path='/remittance/edit/:id' element={<Remittance Id={1} />} />
                    <Route path='/remittances/out' element={<Remittances IO={2} />} />
                    <Route path='/remittances/in' element={<Remittances IO={1} />} />


                    <Route path='/invoice/upload' element={<Upload Type={1} />} />
                    <Route path='/invoice/buy/new1' element={<InvoiceBuy Inp={1} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/buy/edit/:id' element={<InvoiceBuy Inp={0} Id={1} Ins={0} IsNew={false} />} />
                    <Route path='/invoice/sale/new1' element={<InvoiceSale Inp={1} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new2' element={<InvoiceSale Inp={2} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new3' element={<InvoiceSale Inp={3} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new4' element={<InvoiceSale Inp={4} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new5' element={<InvoiceSale Inp={5} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new6' element={<InvoiceSale Inp={6} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/new7' element={<InvoiceSale Inp={7} Id={0} Ins={1} IsNew={true} />} />
                    <Route path='/invoice/sale/edit/:id' element={<InvoiceSale Inp={0} Id={1} Ins={0} IsNew={false} />} />
                    <Route path='/invoice/view/:id' element={<InvoiceView Inp={0} Id={1} Ins={0} IsNew={false} />} />
                    <Route path='/invoices/sale' element={<SaleInvoices />} />
                    <Route path='/invoices/buy' element={<BuyInvoices />} />
                    <Route path='/invoice/cancell/:id' element={<InvoiceSale Inp={0} Id={1} Ins={3} IsNew={true} />} />
                    <Route path='/invoice/return/:id' element={<InvoiceSale Inp={0} Id={1} Ins={2} IsNew={true} />} />
                    <Route path='/invoice/modify/:id' element={<InvoiceSale Inp={0} Id={1} Ins={4} IsNew={true} />} />

                    <Route path='/document/new' element={<Document Id={this.getDefaultGuid()} IsNew={true} />} />
                    <Route path='/document/edit/:id' element={<Document Inp={0} Id={1} Ins={0} IsNew={false} />} />
                    <Route path='/document/view/:id' element={<InvoiceView Inp={0} Id={1} Ins={0} IsNew={false} />} />
                    <Route path='/documents' element={<Documents/>} />



                    <Route path='/document/modify/:id' element={<Document Inp={0} Id={1} Ins={4} IsNew={true} />} />

                    <Route path='/annual/new' element={<Annual Id={this.getDefaultGuid()} />} />
                    <Route path='/annual/edit/:id' element={<Annual Id={1} />} />
                    <Route path='/annuals' element={<Annuals />} />

                    <Route path='/account/new1' element={<Account Type={1} Id={this.getDefaultGuid()} />} />
                    <Route path='/account/new2' element={<Account Type={2} Id={this.getDefaultGuid()} />} />
                    <Route path='/account/new3' element={<Account Type={3} Id={this.getDefaultGuid()} />} />
                    <Route path='/account/edit/:id' element={<Account Type={0} Id={1} />} />
                    <Route path='/accounts' element={<Accounts />} />

                    <Route path='/tafsil/new' element={<Tafsil Id={this.getDefaultGuid()} />} />
                    <Route path='/tafsil/edit/:id' element={<Tafsil Id={1} />} />
                    <Route path='/tafsils' element={<Tafsils />} />

                    <Route path='/person/upload' element={<Upload Type={2} />} />
                    <Route path='/person/new' element={<Person Id={0} />} />
                    <Route path='/person/edit/:id' element={<Person Id={1} />} />
                    <Route path='/persons' element={<Persons />} />


                    <Route path='/warehouse/new' element={<Warehouse Id={this.getDefaultGuid()} />} />
                    <Route path='/warehouse/edit/:id' element={<Warehouse Id={1} />} />
                    <Route path='/warehouses' element={<Warehouses />} />

                    <Route path='/company/setting' element={<CompanySetting />} />
                    <Route path='/company/new' element={<Company Id={0} />} />
                    <Route path='/company/edit/:id' element={<Company Id={1} />} />
                    <Route path='/companies' element={<Companies />} />

                    <Route path='/stuff/upload' element={<Upload Type={3} />} />
                    <Route path='/stuff/new' element={<Stuff Id={0} />} />
                    <Route path='/stuff/edit/:id' element={<Stuff Id={1} />} />
                    <Route path='/stuffs' element={<Stuffs />} />

                    <Route path='/inquiry/economiccode/' element={<InquiryEconomicCode />} />
                    <Route path='/inquiry/stuff/' element={<InquiryStuff />} />

                    <Route path='/mytransactions' element={<MyTransactions />} />

                    <Route path='/paymentfailed/' element={<PaymentFailed />} />

                    <Route path='/user/new' element={<User Id={0} />} />
                    <Route path='/user/edit/:id' element={<User Id={1} />} />
                    <Route path='/users' element={<Users />} />

                    <Route path='/plan/new' element={<Plan Id={0} />} />
                    <Route path='/plan/edit/:id' element={<Plan Id={1} />} />
                    <Route path='/plans' element={<Plans />} />

                    <Route path='/unit/new' element={<Unit Id={0} />} />
                    <Route path='/unit/edit/:id' element={<Unit Id={1} />} />
                    <Route path='/units' element={<Units />} />

                    <Route path='/settings' element={<Setting Id={1} />} />

                    <Route path='/transactions' element={<Transactions />} />
                    <Route path='/basestuffs' element={<BaseStuffs />} />

                    <Route path='/archive' element={<Archive />} />

                    <Route path='/closingdocument' element={<ClosingDocument />} />



                    <Route path='/taxcondition/new' element={<TaxCondition Id={0} />} />
                    <Route path='/taxcondition/edit/:id' element={<TaxCondition Id={1} />} />
                    <Route path='/taxconditions' element={<TaxConditions />} />


                    <Route path='/operation/new' element={<Operation Id={0} />} />
                    <Route path='/operation/edit/:id' element={<Operation Id={1} />} />
                    <Route path='/operations' element={<Operations />} />

                    <Route path='/bank/new' element={<Bank Id={0} />} />
                    <Route path='/bank/edit/:id' element={<Bank Id={1} />} />
                    <Route path='/banks' element={<Banks />} />

                    <Route path='/banktransaction/new' element={<BankTransaction Id={0} />} />
                    <Route path='/banktransaction/edit/:id' element={<BankTransaction Id={1}  />} />
                    <Route path='/banktransactions' element={<BankTransactions />} />

                    <Route path='/pricingremittance' element={<PricingRemittance />} />

                </Routes>
                </Layout>
            </ThemeProvider>
        );
    }
}